import { lazy, Suspense } from 'react';
import { RoleGuard } from '@emfood/shared';
import { Outlet, createRoute, SearchSchemaInput } from '@tanstack/react-router';

import { ROLES } from 'src/api/roles-config';
import DashboardLayout from 'src/layouts/dashboard';

import AppAuthGuard from 'src/components/auth/app-auth-guard';
import { SplashScreen, LoadingScreen } from 'src/components/loading-screen';

import { DataMapperTemplateListSearchParamsSchema } from 'src/sections/data-mapper/template-list/search-params';

import { rootRoute } from './root';

const DataMapperTemplateList = lazy(
  () => import('src/sections/data-mapper/template-list/view')
);
const DataMapperTemplateEdit = lazy(
  () => import('src/sections/data-mapper/template-edit/view')
);

const dataMapperRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'data-mapper',
  component: () => (
    <AppAuthGuard splashScreen={<SplashScreen />}>
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    </AppAuthGuard>
  ),
});

const dataMapperIndexRoute = createRoute({
  getParentRoute: () => dataMapperRoute,
  path: '/',
  validateSearch: (search: unknown & SearchSchemaInput) =>
    DataMapperTemplateListSearchParamsSchema.validateSync(search),
  component: () => (
    <RoleGuard requiredRoles={[ROLES.ADMIN, ROLES.DISTRIBUTOR_ADMIN, ROLES.DATA_MANAGER]}>
      <DataMapperTemplateList />
    </RoleGuard>
  ),
});

const dataMapperTemplateEditRoute = createRoute({
  getParentRoute: () => dataMapperRoute,
  path: '$orgId/$templateId',
  component: () => (
    <RoleGuard requiredRoles={[ROLES.ADMIN, ROLES.DISTRIBUTOR_ADMIN, ROLES.DATA_MANAGER]}>
      <DataMapperTemplateEdit />
    </RoleGuard>
  ),
});

export const dataMapperRouteTree = dataMapperRoute.addChildren([
  dataMapperIndexRoute,
  dataMapperTemplateEditRoute,
]);
